import type { SVGProps } from 'react';
const FileIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={36}
        height={36}
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect x={2} y={2} width={32} height={32} rx={16} fill="#FEE480" />
        <path
            d="M18.666 11.333H13.9993C13.6457 11.333 13.3066 11.4735 13.0565 11.7235C12.8065 11.9736 12.666 12.3127 12.666 12.6663V23.333C12.666 23.6866 12.8065 24.0258 13.0565 24.2758C13.3066 24.5259 13.6457 24.6663 13.9993 24.6663H21.9993C22.353 24.6663 22.6921 24.5259 22.9422 24.2758C23.1922 24.0258 23.3327 23.6866 23.3327 23.333V15.9997M18.666 11.333L23.3327 15.9997M18.666 11.333V15.9997H23.3327"
            stroke="#F18F34"
            strokeWidth={1.33333}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect x={2} y={2} width={32} height={32} rx={16} stroke="#FEEDAA" strokeWidth={3} />
    </svg>
);
export default FileIcon;
